import { sendOpenLink } from "@/modules/helpers/utils/post-message"

/**
 * TikTok Showcase Service ID for creator authorization
 */
export const TIKTOK_SHOWCASE_SERVICE_ID = "7423718357151565573"
export const TIKTOK_SHOWCASE_APP_KEY = "6dvauq2bmjo2p"

/**
 * Generate TikTok Showcase authorization URL
 * @param userId - User ID to include in the state parameter
 * @returns Complete TikTok Showcase authorization URL
 */
export function getTikTokShowcaseUrl(userId: string | number): string {
  return `https://shop.tiktok.com/alliance/creator/auth?app_key=${TIKTOK_SHOWCASE_APP_KEY}&state=user_id%3D${userId}%26`
}

/**
 * Open TikTok Showcase authorization page
 * @param userId - User ID to include in the authorization
 */
export function openTikTokShowcaseAuth(userId: string | number): void {
  const url = getTikTokShowcaseUrl(userId)
  sendOpenLink(url)
}
